import type { Components } from '@mui/material/styles';

export default function MUIImageList(): Components['MuiImageList'] {
  return {};
}
